const dateFormats = {
  basicReadable: 'MMM do, yyyy',
}

export default dateFormats
